import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import ReduxThunk from 'redux-thunk';
import { GoogleOAuthProvider } from '@react-oauth/google';

// Bootstrap
import 'bootstrap/scss/bootstrap-grid.scss';
import '../styles/custom-bs.scss'
import 'bootstrap/dist/js/bootstrap.bundle.min.js';



import './index.scss';
import App from './App';
import appReducer from './App/reducer';
import { googleClientId } from './utils/Shared/constant';

import WebFont from 'webfontloader';

WebFont.load({
  google: {
    families: [
      'Poppins:300,400,500,600,700,800,900',
      'Roboto:300,400,500,700,900',
      'Roboto+Mono:300,400,500,700,900',
      'Roboto+Condensed:400, 700',
      'sans-serif']
  }
});


const createStoreWithMiddleware = applyMiddleware(
  ReduxThunk
)(createStore);

const appStore = createStoreWithMiddleware(appReducer, typeof(window) !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__())

ReactDOM.render(
  <GoogleOAuthProvider clientId={googleClientId}>
    <Provider store={appStore}>
      <App />
    </Provider>
  </GoogleOAuthProvider>
  , document.getElementById('root'));

//ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
// serviceWorker.unregister();
